export default function() {
  let currentIndex = 0;
  const textsElements = document.querySelectorAll(".financial-slide--text");
  const imagesElements = document.querySelectorAll(".financial-slide--image");
  const totalElements = imagesElements.length;

  if (imagesElements.length === 0) {
    return;
  }

  if (imagesElements.length !== textsElements.length) {
    console.warn("slide financial doesn't have equals images and texts");
  }

  const handleClick = (oldIndex, nextIndex) => {
    textsElements[oldIndex].classList.add("tw-hidden");
    imagesElements[oldIndex].classList.add("tw-hidden");

    textsElements[nextIndex].classList.remove("tw-hidden");
    imagesElements[nextIndex].classList.remove("tw-hidden");
  };

  document.querySelector(".financial-slide--prev").onclick = function() {
    const oldIndex = currentIndex;
    const newIndex =
      currentIndex - 1 >= 0 ? currentIndex - 1 : totalElements - 1;
    currentIndex = newIndex;
    handleClick(oldIndex, newIndex);
  };

  document.querySelector(".financial-slide--next").onclick = function() {
    const oldIndex = currentIndex;
    const newIndex = currentIndex + 1 < totalElements ? currentIndex + 1 : 0;
    currentIndex = newIndex;

    handleClick(oldIndex, newIndex);
  };
}
